export default "__VITE_ASSET__BVZIrRVO__"